module.exports = __webpack_public_path__ + "static/media/voucher-icon-active.4e5212e1.svg";